import { render, staticRenderFns } from "./rfm.vue?vue&type=template&id=1a70d86e&scoped=true"
import script from "./rfm.vue?vue&type=script&lang=js"
export * from "./rfm.vue?vue&type=script&lang=js"
import style0 from "./rfm.vue?vue&type=style&index=0&id=1a70d86e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a70d86e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a70d86e')) {
      api.createRecord('1a70d86e', component.options)
    } else {
      api.reload('1a70d86e', component.options)
    }
    module.hot.accept("./rfm.vue?vue&type=template&id=1a70d86e&scoped=true", function () {
      api.rerender('1a70d86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagManage/rfm.vue"
export default component.exports